// extracted by mini-css-extract-plugin
export default {"menuContainer":"Menu_menuContainer__smLe+","menuContent":"Menu_menuContent__W7VWn","noDecoration":"Menu_noDecoration__UYA4s"};